import { render, staticRenderFns } from "./StepNotEligibleMeningitisBAge.vue?vue&type=template&id=2a0d8391&"
import script from "./StepNotEligibleMeningitisBAge.vue?vue&type=script&lang=js&"
export * from "./StepNotEligibleMeningitisBAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports